import { Component, OnInit } from '@angular/core'
import { InlineEditCellDirective } from '../inline-edit-cell'

@Component({
  selector: 'jml-lib-calendar-week-cell',
  templateUrl: './calendar-week-cell.component.html',
  styleUrls: ['../inline-edit-cell.scss']
})
export class CalendarWeekCellComponent extends InlineEditCellDirective implements OnInit {
  ngOnInit(): void {}

  onKeyupEnter(valid: boolean) {
    if (valid) {
      this.isEdited = false
      this.completeCellEdit.emit({ data: this.rowData, field: this.fieldName })
    }
  }

  triggerEdit() {
    setTimeout(() => {
      this.originalContent = this.rowData[this.fieldName]
      this.isEdited = true
    }, 0)
  }
}
